import REGService from "../services/REGService";
import { to, setStateAsync } from "../../utils";
export default class REGManager {
  // ---------- REG

  apiToken: string | null = null;
  regService: REGService;
  constructor(apiToken: string | null = null) {
    this.apiToken = apiToken;
    this.regService = new REGService(apiToken);
  }

  getPatientInfo = async (patientId: any) => {
    var patientInfoData = [];
    var patientInfoError = null;
    const [error, response] = await to(this.regService.getPatientById(patientId));
    if (response) {
      patientInfoData = response;
    } else {
      patientInfoError = error;
    }
    return [patientInfoData, patientInfoError];
  };
  getSearchAllPatient = async (
    { hn, fullName, citizenId, nationality, startAge, endAge, noEncounter, mergeFile, includeCancel, isEmergency, birthdate, showADBirthDate, is_old_name_search, limit, offset }: any = {},
    cancelToken = null
  ) => {
    let params:Record<string, any> = {};
    if (hn) {
      params.hn = hn;
    }
    if (fullName) {
      params.name_search = fullName;
    }
    if (citizenId) {
      params.citizen_passport = citizenId;
    }
    if (nationality) {
      params.nationality = nationality;
    }
    if (startAge) {
      params.start_age = startAge;
    }
    if (endAge) {
      params.end_age = endAge;
    }
    if (noEncounter) {
      params.no_encounter = noEncounter;
    }
    if (mergeFile) {
      params.merge_file = mergeFile;
    }
    if (includeCancel) {
      params.include_cancel = includeCancel;
    }
    if (isEmergency) {
      params.is_emergency = isEmergency;
    }
    if (birthdate){
      params.birthdate = birthdate
    }
    if (showADBirthDate){
      params.show_ad_birthdate = showADBirthDate
    }
    if (is_old_name_search) {
      params.is_old_name_search = is_old_name_search;
    }
    if (limit) {
      params.limit = limit;
    }
    if (offset) {
      params.offset = offset;
    }
    // if (cancelToken) {
    //   params.cancelToken = cancelToken;
    // }

    const [error, response] = await to(this.regService.getSearchAllPatient(params, cancelToken));
    return [response, error];
  };
  getPatientOldName = async (patientId: any) => {
    const [error, response] = await to(this.regService.getPatientName(patientId));
    return [response, error];
  };
  getPatientNameWithID = async (patientId: any) => {
    var nameData = [];
    const [error, response] = await to(this.regService.getPatientName(patientId));
    if (response) {
      nameData = response.items;
    }
    return [nameData, error];
  };

  getPatientByHN = async (params: any) => {
    var patientData = [];
    var patientError = [];
    const [error, response, network] = await to(this.regService.getPatientByHN(params));
    if (response) {
      patientData = response;
    } else {
      patientError = error;
    }
    return [patientData, patientError, network];
  };

  getBloodType = async ({ apiToken }: any={}) => {
    var data = [];
    var err = null;
    let params = {};
    const [error, response] = await to(this.regService.getBloodType({ params, apiToken }));
    if (response) {
      data = response.items;
    } else {
      err = error;
    }
    return [data, err];
  };
}
